// extracted by mini-css-extract-plugin
export var orderSummary = "_r2-0";
export var showMoreLessButton = "_r2-1";